import { useRef } from 'react';
import { useScaleCanvas } from '../../use-scale-canvas';
import sparkleDoodle from '../OrgImages/Sparkledoodle.svg';
import sparkIcon from '../OrgImages/spark, sparkle, 26 (4).svg';
import repAvatarCard from '../OrgImages/repavatarcard.svg';

const CANVAS_W = 640;
const CANVAS_H = 660;

export const OrgRepBackgroundShowcase = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { wrapperStyle, canvasStyle } = useScaleCanvas(sectionRef, CANVAS_W, CANVAS_H, 'contain');

  return (
    <section ref={sectionRef} className='relative h-full w-full overflow-hidden bg-warning-50'>
      <div className='flex h-full w-full items-center justify-center'>
        <div style={wrapperStyle}>
          <div style={canvasStyle}>
            <h1
              className="m-0 text-display-lg font-bold text-gray-700 text-center"
              style={{ position: 'absolute', top: 72, left: 60, width: 520 }}
            >
              Visibility builds trust <br />
              —and sparks action.
            </h1>

            <img
              src={sparkIcon}
              alt=''
              className='absolute'
              style={{ top: 172, left: 86, width: 140, height: 140 }}
            />

            <img
              src={repAvatarCard}
              alt=''
              className='absolute'
              style={{ top: 244, left: 146, width: 365, height: 282 }}
            />

            <img
              src={sparkleDoodle}
              alt=''
              className='absolute'
              style={{ top: 470, left: 436, width: 165, height: 165 }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

